import React from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { WorkWithMetadata } from './shared/types';
import { Name as NameBase } from './shared/Avatar';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { ImpressionEntity } from 'js/utils/impressions/watchImpressions';
import { getSocialImpressionSource } from './ImpressionHelper';

interface Props {
  work: WorkWithMetadata;
}

const IMPRESSION_PAGE = 'home';
const IMPRESSION_SECTION = 'read';

const TitleText = styled(NameBase)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 500;
  color: $ds-black;
`;

const Authors = styled(Body)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  color: $ds-gray-dark;
  font-size: 12px;
  line-height: 18px;
`;

export const ContinueReadingWorkCard: React.FC<Props> = ({ work }) => {
  const publicationInfo: string[] = [];
  if (work.createdAt) {
    publicationInfo.push(new Date(work.createdAt).getFullYear().toString());
  }
  if (work.publication) {
    publicationInfo.push(work.publication);
  }

  return (
    <ImpressionWatcher
      source={getSocialImpressionSource(
        IMPRESSION_PAGE,
        IMPRESSION_SECTION,
        'paper',
      )}
      entity_type={ImpressionEntity.Work}
      entity_id={work.id}
    >
      <TitleText href={work.url}>{work.title}</TitleText>
      <Authors size="sm">{work.authors.join(', ')}</Authors>
    </ImpressionWatcher>
  );
};
